module.exports = __webpack_public_path__ + "static/media/tic-ms-end-users-icon.208341b7.png";